module.exports = __webpack_public_path__ + "static/media/gettingStarted.d35acdad.png";